<template>
  <div class="container">
    <div class="row">

      <Teleport to="body">
        <!-- EDITOR WRAPPER-->
        <div class="overlay-editor client-profile-editor">
          <div class="overlay-editor-wrapper" v-if="selected">
            <div class="panel-top">
              <div class="panel-top-name">{{ $static('users.edit', 'Редагування профілю клієнта') }}</div>
              <a href="javascript:void(0);" class="back_trigger" @click="close">
                <span class="icon icon-cross"></span>
              </a>
            </div>
            <div class="panel-middle">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label class="custom-label">{{ $static('users.uid', 'User ID:') }}</label>
                    <div class="to-chat">
                      <div class="user-id-prev">
                        <span class="name">{{ selected.telegram_id }}</span>
                      </div>
                      <div class="button-holder">
                        <Popper arrow content="Coming Soon" hover placement="left" style="white-space: nowrap">
                          <button class="default-btn btn-with-icon btn-accent" disabled>
                            <span class="text">{{ $static('users.chat', 'Чат') }}</span>
                            <span class="icon icon-chat"></span>

                          </button>
                        </Popper>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label class="custom-label">{{ $static('users.t2_1', 'Telegram username:') }}</label>
                    <input type="text" class="form-control custom-input"
                      :value="selected.username ? '@' + selected.username : ''" disabled="">
                  </div>
                </div>
                <div class="col">
                  <div class="option-line blacklist">
                    <div class="option-name">{{ $static('users.block', 'Додати до чорного списку') }}</div>
                    <div class="toggle-holder">
                      <div class="toggler r">
                        <input type="checkbox" class="toggle-check" v-model="info.ban">
                        <div class="knobs"></div>
                        <div class="layer"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label class="custom-label">{{ $static('users.e1', 'Ім\'я:') }}</label>
                    <input type="text" class="form-control custom-input" v-model="info.name">
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label class="custom-label">{{ $static('users.e2', 'Прізвище:') }}</label>
                    <input type="text" class="form-control custom-input" v-model="info.surname">
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label class="custom-label">{{ $static('users.e3', 'По батькові:') }}</label>
                    <input type="text" class="form-control custom-input" v-model="info.second_name">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label class="custom-label">{{ $static('users.e4', 'Телефон:') }}</label>
                    <input type="text" class="form-control custom-input" v-model="info.phone">
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label class="custom-label">{{ $static('users.e5', 'Email:') }}</label>
                    <input type="text" class="form-control custom-input" v-model="info.email">
                  </div>
                </div>
              </div>

              <div class="panel panel-bordered client-order-info row ">
                <div class="col client-order-info-col">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="custom-label">{{ $static('users.e6', 'Кількість замовлень:') }}</div>
                    <div class="value">{{ selected.order_count }}</div>
                  </div>
                </div>
                <div class="col client-order-info-col">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="custom-label">{{ $static('users.e7', 'Загальна сума замовлень,') }}
                      {{ $store.getters.symbol }}:</div>
                    <div class="value">{{ selected.total }}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label class="custom-label bold-label">{{ $static('users.e8', 'Історія замовлень:') }}</label>
                  <div class="table-wrapper">
                    <table class="table custom-table">
                      <thead>
                        <tr>
                          <!--                        <th>№</th>-->
                          <th>{{ $static('users.r1', 'Номер замовлення') }}</th>
                          <th>{{ $static('users.r2', 'Позиції замовлень') }}</th>
                          <th>{{ $static('users.r3', 'Вартість') }}, {{ $store.getters.symbol }}</th>
                          <th>{{ $static('users.r4', 'Час замовлення') }}</th>
                          <th>{{ $static('users.r5', 'Статус замовлення') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(order, index) in client_items" :key="order.id">
                          <!--                        <th scope="row">1</th>-->
                          <td scope="row" class="w-standart">
                            <a href="javascript:void(0)" class="bold" @click="openOrderEditor(order)">#{{ order.id
                              }}</a>
                          </td>
                          <td>
                            <div class="text">{{ getItemTitle(order) }}</div>
                          </td>
                          <td class="w-standart">{{ order.total }}</td>
                          <td class="w-standart">{{ order.created_at.toLocaleString(currentLang) }}</td>
                          <td class="label-td ">
                            <div class="label-status" :class="status[order.status]">{{ order.status }}</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <label class="custom-label bold-label">{{ $static('users.e9', 'Замітки про клієнта:') }}</label>
                  <textarea rows="15" class="form-control custom-input" v-model="info.comment"></textarea>
                </div>
              </div>

            </div>
            <div class="panel-bottom">
              <button class="transparent-btn default-btn back_trigger" @click="close">
                <span class="text">{{ $static('users.cancel', 'Скасувати') }}</span>
              </button>
              <button class=" default-btn btn-accent" @click="save">
                <span class="text">{{ $static('users.save', 'Зберегти зміни') }}</span>
              </button>
            </div>
          </div>
        </div>
        <!--END EDITOR WRAPPER-->
      </Teleport>

      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">
          <h1>{{ $static('subscribers.title', 'Вся база') }}</h1>
        </div>
        <div class="large-button-panel client-search-panel">
          <div class="search-panel w-100">
            <!--search panel-->
            <div class="search-group">
              <form @submit.prevent="getItems" autocomplete="off">
                <input type="text" name="input_search_subscribers" class="input-search form-control custom-input"
                  :placeholder="$static('users.search', 'Пошук за ідентифікатором/іменем користувача')"
                  v-model="filter.search">
                <button type="submit" class="search-btn">
                  <span class="icon icon-search"></span>
                </button>
              </form>
            </div>
            <!-- end search panel-->
          </div>
        </div>

        <div class="table-wrapper">
          <div class="table-responsive">
            <table class="table custom-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>User ID</th>
                  <th>{{ $static('subs.w2', 'Ім\'я') }}</th>
                  <th>{{ $static('subs.w3', 'Прізвище') }}</th>
                  <th>{{ $static('subs.w4_11', 'Telegram username') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(sub, index) in items" :key="index">
                  <th scope="row">{{ sub.id }}</th>
                  <td class="w-standart">
                    <div class="user-id-prev">
                      <!--                    <span class="avatar bg" :style="{'background-image': getAvatar(user)}"></span>-->
                      <span class="name">{{ sub.user_id }}</span>
                    </div>
                  </td>
                  <td class="w-standart">{{ sub.first_name }}</td>
                  <td class="w-standart">{{ sub.second_name }}</td>
                  <td class="w-standart"><a :href="'https://t.me/' + sub.username" v-if="sub.username">@{{ sub.username
                      }}</a></td>

                  <td>
                    <Popper arrow :content="$static('iconsbtn.chat', 'Чат (Coming Soon)')" hover placement="top"
                      style="white-space: nowrap;">
                      <button class="btn-icon btn-rounded btn-icon-transparent profile_edit"
                        style="opacity: 0.1; cursor: not-allowed">
                        <span class="icon icon-chat"></span>
                      </button>
                    </Popper>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="pagination-panel table-pagination" v-if="pages.length > 1">
          <nav>
            <router-link :to="{ name: 'Subscribers', params: { page: Math.max(pageIndex - 1, 1) } }"
              class="previous extreme" :class="{ 'disabled': pageIndex < 2 }">
              <span class="icons icon-left"></span>
            </router-link>
            <ul class="pagination pagination-list">
              <li v-for="(page, index) in pages" :key="index" :class="{ 'active': pageIndex === page }">
                <router-link :to="{ name: 'Subscribers', params: { page: page } }">{{ page }}</router-link>
              </li>
            </ul>
            <router-link :to="{ name: 'Subscribers', params: { page: Math.min(pageIndex + 1, pageAmount) } }"
              class="end extreme" :class="{ 'disabled': pageIndex > pageAmount - 1 }">
              <span class="icons icon-right"></span>
            </router-link>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
// import CatalogProductPreview from '../components/CatalogProductPreview';
// import EditItemAdmin from '../components/EditItemAdmin';

const pageSlotsAmount = 5;

export default {
  name: 'Subscribers',
  props: ['page'],
  data() {
    return {
      selected: undefined,
      filter: {
        page: 1,
        perPage: 10,
        search: undefined
      },
      client_filter: {
        page: 1,
        perPage: 5,
        user_id: undefined
      },
      sortBy: 'time',
      items: [],
      client_items: [],
      total: 0,
      client_total: 0,
      status: {
        'Новый': 'label-new',
        'Отправлен': 'label-send',
        'Доставлен': 'label-delivered',
        'Возврат': 'label-return',
        'В обработке': 'label-proccess'
      }
    }
  },
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.filter.perPage)
    },
    pages() {
      if (this.pageAmount < pageSlotsAmount) return [...Array(this.pageAmount).keys()].map(x => x + 1);

      let min = Math.max(this.pageIndex - (pageSlotsAmount - 1) / 2, 1);
      if (this.pageIndex + 1 >= this.pageAmount) {
        min = this.pageAmount - 4;
      }
      let result = [...Array(pageSlotsAmount).keys()].map(x => x + min);
      result[0] = 1;
      result[pageSlotsAmount - 1] = this.pageAmount;

      return result;
    },
    pageAmount() {
      return Math.ceil(this.total / this.filter.perPage);
    },
    pageIndex() {
      return (this.page && Number.isInteger(+this.page)) ? +this.page : 1;
    },
    info: {
      get() {
        return this.selected.info ? this.selected.info : {}
      },
      set(value) {
        this.selected.info = value
      }
    },
    currentLang() {
      const currentLang = localStorage.getItem('$lang');
      console.log(currentLang)
      if (currentLang && currentLang !== "" && currentLang !== "ua") {
        return currentLang
      }
      return "uk"
    }
  },
  mounted() {
    window.$('.select-custom').selectpicker();
    this.getItems();
  },
  methods: {
    close() {
      window.$('body').removeClass('is-hidden');
      window.$('.back-blur').removeClass('active');
      window.$('body > .client-profile-editor.active').removeClass('active');
    },
    getItems() {
      api.post('/api/subscriber/filter', { filter: this.filter, sortBy: this.sortBy }).then(response => response.data).then(
        data => {
          this.items = data.result.map(i => {
            i.created_at = new Date(i.created_at);
            i.updated_at = new Date(i.updated_at);

            return i
          });
          this.filter.page = data.page;
          this.total = data.total;
        })
    },
    getClientOrders() {
      api.post('/api/order/filter', { filter: this.client_filter, sortBy: this.sortBy }).then(response => response.data).then(
        data => {
          this.client_items = data.result.map(i => {
            i.created_at = new Date(i.created_at);
            i.updated_at = new Date(i.updated_at);

            return i
          });
          this.client_filter.page = data.page;
          this.client_total = data.total;
        })
    },

    getInfo(item) {
      return Object.assign({}, item.info, item.telegram)
    },
    getAvatar(item) {
      return item.telegram && item.telegram.photo ? item.telegram.photo : 'url(\'/images/avatar.png\')'
    },
    openOrderEditor(item, event) {
      window.openOrder(item);
    },
    openEditor(item, event) {
      this.selected = Object.assign({}, item);

      window.$('body').addClass('is-hidden');
      window.$('.back-blur').addClass('active');
      window.$('.client-profile-editor').addClass('active');
    },
    save() {
      let obj = Object.assign({}, this.selected, { info: this.info });

      api.put('/api/client', obj).then(response => response.data).then(item => {
        item.created_at = new Date(item.created_at);
        item.updated_at = new Date(item.updated_at);
        let idx = this.items.findIndex(i => i.id === item.id);
        this.items[idx] = item;
      });

      window.$('body').removeClass('is-hidden');
      window.$('body > .active').removeClass('active');
    },
    onSave(item) {
      item.created_at = new Date(item.created_at);
      item.updated_at = new Date(item.updated_at);
      let idx = this.items.findIndex(i => i.id === item.id);
      this.items[idx] = item;
    },
    onAdd(item) {
      this.items.unshift(item)
    },
    getItemTitle(item) {
      return item.info.busked.map(i => i.title).join(' | ')
    }
  },
  watch: {
    page(val) {
      this.filter.page = val;
      this.getItems()
    },
    'selected.id'(val) {
      this.client_filter.user_id = val;
      this.getClientOrders()
    }
  }
}
</script>

<style scoped></style>